
import { MyPublicProfileModel, MyPublicProfileResult, UpdatePublicProfileApiParameter, updatePublicProfileWithResult } from "@dana/Services/DanaMyPublicProfileService";
import { MyPublicProfileActions } from "@dana/Store/Data/MyPublicProfile/Reducers/MyPublicProfileReducer";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { DispatchProp } from "react-redux";

type UpdateUserParameter = {
    
    onError?: (error: string) => void;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<UpdateUserParameter, UpdatePublicProfileApiParameter, ServiceResult<MyPublicProfileResult>, DispatchProp<MyPublicProfileActions>>;

export const DispatchBeginLoadAccount: HandlerType = props => {
    props.dispatch({
        type: "MyPublicProfile/BeginLoad",
        isLoading: true,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter as UpdatePublicProfileApiParameter;
};

export const UpdateAccount: HandlerType = async props => {
    props.apiResult = await updatePublicProfileWithResult(props.apiParameter);
};
export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "MyPublicProfile/CompleteLoadProfile",
            myPublicProfile: props.apiResult.result.publicProfile,
        });
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};
export const SetLoadingOff: HandlerType = props => {
    props.dispatch?.({
        type: "MyPublicProfile/EndLoad",
        isLoading: false,
    });
}

export const chain = [
    DispatchBeginLoadAccount,
    PopulateApiParameter,
    UpdateAccount,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    SetLoadingOff
];

const updateMyPublicProfile = createHandlerChainRunner(chain, "UpdateMyPublicProfileHandler");
export default updateMyPublicProfile;
